module.exports = __webpack_public_path__ + "static/media/  (131).76787a4a.jpg";